import PropTypes from 'prop-types';
import Constants from '../../../flux/Constants.js';

const RATINGS = Constants.FEEDBACK_RATINGS;

const IconButton = ({ isSelected, onClick, type }) => {
	const iconClass = isSelected ? `${type}-full` : `${type}-line`;

	const onClickHandler = (event) => {
		event.preventDefault();
		event.stopPropagation();
		onClick();
	};

	return (
		<button onClick={(event) => onClickHandler(event)}>
			<i className={`icon h-cursor-pointer -size-sm -icon-${iconClass}`} />
		</button>
	);
};

IconButton.propTypes = {
	onClick: PropTypes.func,
	isSelected: PropTypes.bool,
	type: PropTypes.oneOf(['like', 'unlike']).isRequired,
};

const FeatureFeedbackPopupRatingButtonsLikes = ({ selectedRating, onSelectRating }) => (
	<div className="feature-feedback__popup__rating-buttons--likes">
		<IconButton type={'like'} key={RATINGS.GREAT} onClick={() => onSelectRating(RATINGS.GREAT)} isSelected={selectedRating === RATINGS.GREAT} />
		<IconButton type={'unlike'} key={RATINGS.BAD} onClick={() => onSelectRating(RATINGS.BAD)} isSelected={selectedRating === RATINGS.BAD} />
	</div>
);

FeatureFeedbackPopupRatingButtonsLikes.propTypes = {
	selectedRating: PropTypes.string,
	onSelectRating: PropTypes.func,
};

export default FeatureFeedbackPopupRatingButtonsLikes;
